import React from 'react'
import { isSaficDomain, isSjDomain ,isKsDomain } from 'utils/domain'

import SaficBackGroundGradient from './SaficBackGroundGradient'
import SjBackground from './SjBackground'
import KsBackground from './KsBackground'

/**
 * メイン画面の背景
 */
const BackGroundGradient: React.FC<BackGroundGradientProps> = (props) => {
  return (
    <React.Fragment>
      {isSaficDomain() && <SaficBackGroundGradient {...props} />}
      {isSjDomain() && <SjBackground {...props} />}
      {isKsDomain() && <KsBackground {...props} />}
    </React.Fragment>
  )
}

export type BackGroundGradientProps = {
  children?: React.ReactNode
  background?: string
}

export default BackGroundGradient
